export default "__VITE_ASSET__CKwDoUGY__"